module.exports = __webpack_public_path__ + "img/char2.89bfd572.png";